import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid2,
} from "@mui/material";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateProjectPrice } from "../../apis/apisList/adminApi";

// const ChangePrice = ({ fetchTrigger, setFetchTrigger }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   return (
//     <div>
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={() => setIsOpen(true)}
//       >
//         Change Price
//       </Button>
//       <ChangePriceModal
//         open={isOpen}
//         onClose={() => setIsOpen(false)}
//         fetchTrigger={fetchTrigger}
//         setFetchTrigger={setFetchTrigger}
//       />
//     </div>
//   );
// };

const ChangePriceModal = ({
  open,
  onClose,
  fetchTrigger,
  setFetchTrigger,
  selectPrice,
}) => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    index: selectPrice?.index,
    price: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const value = parseFloat(formData?.price);

    if (isNaN(value) || value < 0) {
      newErrors.price = "Please enter a valid positive number";
    }
    // if (!formData?.reason.trim()) {
    //   newErrors.reason = "Full name is required.";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        let sendData = {
          ...formData,
          index: selectPrice?.index,
        };
        updateProjectPrice(id, sendData).then((res) => {
          if (res?.success) {
            toast.success(res?.message);
            onClose();
            setFormData({
              price: "",
              reason: "",
            });
            setFetchTrigger(!fetchTrigger);
          } else {
            toast.error(res?.message);
          }

          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
      } catch (error) {
        toast.error("Something went wrong.");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <DialogTitle id="alert-dialog-title">Change Project Price</DialogTitle>
        <DialogContent>
          <Grid2 container spacing={1} gap={3}>
            <Grid2 size={{ xs: 12, md: 12 }}>
              <TextField
                name="price"
                id="price"
                label="Price"
                value={formData?.price}
                onChange={(e) => {
                  handleChange(e);
                }}
                error={!!errors.price}
                helperText={errors.price}
                variant="standard"
                fullWidth
                type="number"
              />
            </Grid2>
            {/* <Grid2 size={{ xs: 12, md: 12 }}>
              <TextField
                id="filled-textarea"
                label="Reason"
                placeholder="Enter Reason"
                multiline
                name={`reason`}
                value={formData?.reason}
                onChange={(e) => {
                  handleChange(e);
                }}
                error={!!errors.reason}
                helperText={errors.reason}
                rows={4}
                variant="standard"
                fullWidth
              />
            </Grid2> */}
          </Grid2>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            color="warning"
            variant="contained"
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangePriceModal;
